import React from 'react';
import { Carousel } from 'react-responsive-carousel';

import { PrevControl, ControlTextIcon, PrevArrow, NextControl, NextArrow } from './styled';
import ProfileStrengtheningSlide from '../ProfileStrengtheningSlide/index';
import { getSlides } from '../../../helpers/profileStrength.helpers';
import TrophyIcon from '../../../../images/MyICSC-Complete.svg';
import useViewer from '@hooks/useViewer';

const ProfileStrengtheningCarousel = () => {
    const { loading, error, viewer } = useViewer();
    if (loading || !viewer) return null;

    const slides = getSlides(viewer);

    const renderCarousel = () => (
        <Carousel
            className="profile-strengthening-carousel"
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            infiniteLoop
            renderArrowPrev={(onClickHandler, hasPrev, label) => {
                if (slides.length === 1) return null;
                return (
                    <PrevControl onClick={onClickHandler} aria-hidden="true">
                        <ControlTextIcon>
                            <PrevArrow />
                            Prev
                        </ControlTextIcon>
                    </PrevControl>
                );
            }}
            renderArrowNext={(onClickHandler, hasPrev, label) => {
                if (slides.length === 1) return null;
                return (
                    <NextControl onClick={onClickHandler} aria-hidden="true">
                        <ControlTextIcon>
                            Next
                            <NextArrow />
                        </ControlTextIcon>
                    </NextControl>
                );
            }}
        >
            {slides.map((slide, i) => (
                <ProfileStrengtheningSlide {...slide} key={i} />
            ))}
        </Carousel>
    );

    if (slides.length > 0) return renderCarousel();

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="mr-3">
                <img src={TrophyIcon} alt="" style={{ width: 70 }} />
            </div>

            <div>
                <h5 style={{ fontSize: '1.15rem' }}>Congratulations! You've built a strong profile.</h5>
            </div>
        </div>
    );
};

export default ProfileStrengtheningCarousel;
